window.addEventListener('load', () => {
    let heroVids = document.querySelectorAll('.hero-banner-video');
    let docBody = document.body;

    const playVideo = () => {
        for (let heroVid of heroVids) {
            heroVid.play();
        }

        docBody.removeEventListener('touchstart', playVideo);
    }

    if (window.matchMedia('(max-width:640px)').matches) {
        docBody.addEventListener('touchstart', playVideo);
    }
});
